const getIdFromRoute = (pathname: string, key: string): number | null => {
    const locationArray = pathname.split('/');
    const index = locationArray.indexOf(key);
    const id = Number(locationArray[index + 1]);
    return Number.isNaN(id) ? null : id;
};

export default getIdFromRoute;
